import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { Box, Checkbox, FormControlLabel, Button } from '@mui/material'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../common/dropDownOA'
import LineInputV3 from '../../../common/lineInputV3'
import { ReportHeading } from '../common/ReportHeading'
import moment from 'moment'
import { connect } from 'react-redux'
import { GetLRDetailsForPopUpV2Data, getLuggageModificationReportData } from '../../../../store/reports/reports_action'
import LuggageModel from './LuggageModel'
import { appendToUrl, getInt, isEmpty, removeDuplicatesFromArray } from '../../../common/helper'
import { getFtlBkngBranchList, updateLoader } from '../../../../store/common/common_action'
import * as URL from '../oldReportsUrls'
import { urls } from '../../../common/constants'
import { GetRequest } from '../../../common/api'
import Alert from '../../../common/alert'
import { PDFHeaderColumns, PDFHeaderColumnsForBoth, PDFHeaderColumnsForBothTwo, PDFHeaderColumnsFormattedLRNO, PDFHeaderColumnsFormattedLRNOTwo, PDFHeaderColumnsTwo } from './constant'
import { exportToExcel } from '../../../common/hook'
import { useSearchParams } from 'react-router-dom'
import { useAtom } from 'jotai'
import useToken from '../../../helpers/useTokens'
import { companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { getDecryptedReportParams } from '../../../common/loginDecode'
const LuggageModificationReport = (props) => {
  const {
    data: { common, reports, branchAndUserMasterReducer },
    getFtlBkngBranchList,
    getLuggageModificationReportData,
    GetLRDetailsForPopUpV2Data,
    updateAlertError,
    updateModal,
    updateLoader,
  } = props
  const { BranchDetailsList } = branchAndUserMasterReducer
  const { lrDetailsPopupData } = reports
  const reportName = 'Luggage Modification'
    
  const [companySettings] = useAtom(companySettingsAtom)
  const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)
  const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intBranchCityID = +searchParams.get('CT') || 0
    loginData.intUserID = +searchParams.get('U') || 0
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    isFromUrl = true
  }
  const { intCompanyID, intUserID, intBranchID, intBranchCityID, strCompanyName } = loginData

  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [lrSearchCheck, setLrSearchCheck] = useState(false)
  const [showModel, setShowModel] = useState(false)
  const [tableData, setTableData] = useState([])
  const [branchList, setBranchList] = useState([])
  const [branchListData, setBranchListData] = useState([])
  const [selBranch, setSelBranch] = useState('')
  const [showTable, setShowTable] = useState(false)
  const [lRInput, setLRInput] = useState('')
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: ''
  })
  const showAllLrOption = companySettings?.IsShowAllLROption
  const loginCountryId = companySettings[0]?.DefaultCurrencyID
  const headerDataCol =
    UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1
      ? loginCountryId !== 2
        ? PDFHeaderColumns
        : PDFHeaderColumnsTwo
      : UseFormattedLRinReports === 2
        ? loginCountryId !== 2
          ? PDFHeaderColumnsFormattedLRNO
          : PDFHeaderColumnsFormattedLRNOTwo
        : loginCountryId !== 2
          ? PDFHeaderColumnsForBoth
          : PDFHeaderColumnsForBothTwo
  const criteriaHeaders = [
    { field: 'fromDate', header: 'From Date', textAlign: 'left' },
    { field: 'toDate', header: 'To  Date', textAlign: 'left' },
    { field: 'selFromBranch', header: 'From Branch', textAlign: 'left' },
    { field: 'lrSearch', header: 'LR Search', textAlign: 'left' },
  ]
  const criteriaData = {
    fromDate: fromDate.format('DD-MM-YYYY') || '',
    toDate: toDate.format('DD-MM-YYYY') || '',
    selFromBranch: selBranch?.BranchName,
    lrSearch: lRInput,
    dataType: 'entry',
  }
  useEffect(() => {
    if (!lrSearchCheck) {
      setLRInput('')
    }
  }, [lrSearchCheck])
  useEffect(() => {
    if (branchList?.length > 0 && loginData) {
      const branches = branchList.map((record) => ({
        BranchID: record.BranchID,
        BranchName: record.BranchName,
      }))
      setBranchListData(branches)
      const defaultBranch = branches.find((branch) => branch.BranchID === intBranchID)
      setSelBranch(defaultBranch || branches[0])
    }
  }, [branchList])
  
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let BranchBody = {
        intUserID: intUserID,
        intCompanyID: intCompanyID,
        intCityID: 0,
        intBookingBranchID: -1,
      }
      getFtlBkngBranchList(BranchBody)
        .then((res) => {
          if (res.status === 'Success') {
            setBranchList(res?.Data?.Table)
          } else {
            setBranchList([])
          }
        })
        .catch((err) => {
          console.log('Error:', err)
        })
    }
  }, [intUserID])
  const addTotalRow = (data = []) => {
    const totals = data.reduce(
      (acc, val) => {
        acc.ItemsOld += Number(val.ItemsOld || 0)
        acc.ItemsNew += Number(val.ItemsNew || 0)
        acc.FreightOld += Number(val.FreightOld || 0)
        acc.FreightNew += Number(val.FreightNew || 0)
        acc.DocumentChargesOld += Number(val.DocumentChargesOld || 0)
        acc.DocumentChargesNew += Number(val.DocumentChargesNew || 0)
        acc.ServiceTaxAmountOld += Number(val.ServiceTaxAmountOld || 0)
        acc.ServiceTaxAmountNew += Number(val.ServiceTaxAmountNew || 0)
        acc.InsuranceOld += Number(val.InsuranceOld || 0)
        acc.InsuranceNew += Number(val.InsuranceNew || 0)
        acc.DeliveryChargesOld += Number(val.DeliveryChargesOld || 0)
        acc.DeliveryChargesNew += Number(val.DeliveryChargesNew || 0)
        acc.CollectionChargesOld += Number(val.CollectionChargesOld || 0)
        acc.CollectionChargesNew += Number(val.CollectionChargesNew || 0)
        acc.CartageAmountOld += Number(val.CartageAmountOld || 0)
        acc.CartageAmountNew += Number(val.CartageAmountNew || 0)
        acc.NetAmountOld += Number(val.NetAmountOld || 0)
        acc.NetAmountNew += Number(val.NetAmountNew || 0)
        acc.CommissionOld += Number(val.CommissionOld || 0)
        acc.CommissionNew += Number(val.CommissionNew || 0)
        acc.DemurrageChgOld += Number(val.DemurrageChgOld || 0)
        acc.DemurrageChgNew += Number(val.DemurrageChgNew || 0)
        acc.HamaliChargesOld += Number(val.HamaliChargesOld || 0)
        acc.HamaliChargesNew += Number(val.HamaliChargesNew || 0)

        return acc
      },
      {
        ItemsOld: 0,
        ItemsNew: 0,
        FreightOld: 0,
        FreightNew: 0,
        DocumentChargesOld: 0,
        DocumentChargesNew: 0,
        ServiceTaxAmountOld: 0,
        ServiceTaxAmountNew: 0,
        InsuranceOld: 0,
        InsuranceNew: 0,
        DeliveryChargesOld: 0,
        DeliveryChargesNew: 0,
        CollectionChargesOld: 0,
        CollectionChargesNew: 0,
        CartageAmountOld: 0,
        CartageAmountNew: 0,
        NetAmountOld: 0,
        NetAmountNew: 0,
        CommissionOld: 0,
        CommissionNew: 0,
        DemurrageChgOld: 0,
        DemurrageChgNew: 0,
        HamaliChargesOld: 0,
        HamaliChargesNew: 0,
      }
    )

    return [
      ...data,
      {
        LRNO: "Total",
        ...totals,
        dataType: "total",
        IsRefund: 0,
        colSpan: {
          LRNO: 42
        },
        align: {
          LRNO: 'right'
        }
      },
    ]
  }
  const handleClick1 = (isExcel = false, lrItem = null) => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setShowAlert({ show: true, message: 'This report cannot be taken for more than 31 days' })
      return
    }
    setShowTable(true)
    if (lrItem || !lrSearchCheck) {
      const obj = {
        CompanyID: intCompanyID,
        dtDateFrom: moment(fromDate).format('YYYY-MM-DD'),
        dtDateTo: moment(toDate).format('YYYY-MM-DD'),
        FromBranchId: selBranch?.BranchID,
        LRNo: lrItem?.LRNo || '',
        Mode: lrItem ? 1 : 0,
        BookingID: lrItem?.BookingId || 0,
      }
      updateLoader(true)
      GetRequest(urls.getLuggageModificationReport, obj).then((res) => {
        if (res.status == 'Success') {
          setShowModel(false)
          //  setShowReport(true)
          updateLoader(false)
          const data = res?.Data?.table?.map((val, index) => ({ ...val, dataType: 'entry' }))
          if (data?.length === 0) {
            setShowAlert({ show: true, message: 'No Data Found!' })
            return
          }
          const finalData = addTotalRow(data)
          // setTableData(data)
          let mainHeader = headerDataCol?.map((val) => ({
            ...val,
            field: val.field,
            align: val.align,
            export: val.exportHead,
            weight: 80,
            width: getInt(val.minWidth),
          }))
          const reportPayload = {
            reportName,
            criteriaHeaders: criteriaHeaders,
            criteriaData: [criteriaData],
            tableData: finalData,
            mainHeader: mainHeader,
            isShowPdfPrint: false,
          }
          if (isExcel === true) {
            const excelHeaders = mainHeader.map(col => ({
              ...col,
              field: col.field,
              header: col.exportHead || col.header,
              align: col.align,
              weight: 80,
            }))

            const span1 = [Math.ceil(excelHeaders.length / 2), Math.floor(excelHeaders.length / 2)]

            const header1 = [[
              { header: `Report For: ${reportName}`, field: '', span: span1[0], mainHeader: true },
              { header: `Company Name : ${strCompanyName}`, field: '', span: span1[1] },
            ]]

            exportToExcel({
              fileName: `${reportName} ${moment().format('DD-MMM-YYYY HH:mm')}.xlsx`,
              sheetName: reportName,
              headersList: [header1, criteriaHeaders, excelHeaders],
              dataList: [[], [criteriaData], finalData],
            })
            return
          }
          const rid = Date.now().toString()
          if (!window.generatedReports) {
            window.generatedReports = {}
          }
          window.generatedReports[rid] = reportPayload
          window.open(`/view-report?rid=${rid}`, "_blank")
        }
        else {
          updateLoader(false)
          setShowAlert({ show: true, message: res?.ErrMessage })
        }
      }).catch((err) => {
        updateLoader(false)
        console.log('Error:', err)
      })
      //  getLuggageModificationReportData(obj)
    } else {
      const obj2 = {
        strLRNO: lRInput,
        intCompanyID: intCompanyID,
        intBranchID: intBranchID,
        intUserID: intUserID,
        intBranchCityID: intBranchCityID,
        intLrShowMode: (loginData?.IsAdmin || loginData?.IsBranchAdmin || showAllLrOption) ? 3 : 4,
      }
      GetLRDetailsForPopUpV2Data(obj2)
      setShowModel(true)
    }
  }
  const handleClose = () => {
    setShowModel(false)
  }
  const handleClick2 = () => {
    let url = URL.lugguageModificationReport
    let urlData = URL.lugguageModificationReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.dtDateFrom = fromDate.format('DD-MMM-YYYY')
    urlData.dtDateTo = toDate.format('DD-MMM-YYYY')
    urlData.FromBranchId = selBranch?.BranchID
    urlData.FromBranch = selBranch?.BranchName
    urlData.LRNo = 0
    urlData.BookingID = 0
    urlData.intAllowExportToExcel = 1
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handleCloseAlert = () => {
    setShowAlert({ show: false, message: '' })
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <ReportHeading reportName={reportName} />}
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
          <Item sx={sx.itemsxGrow} style={{ width: isFromUrl ? '100%' : '5%' }} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={'From Date'}
              id={'fromDate'}
              dateChange={(date) => {
                setFromDate(date)
                setShowTable(false)
                // focusElemnt(id.toDate)
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: isFromUrl ? '100%' : '5%' }} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Date'}
              value={toDate}
              id={'toDate'}
              dateChange={(date) => {
                setToDate(date)
                setShowTable(false)
                // focusElemnt("goodGoBtn")
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={'fromBranch'}
              label={'From Branch'}
              searchPlaceholder={`Search Selected From Branch`}
              defaultvalue={selBranch?.BranchName || ''}
              data={removeDuplicatesFromArray(branchListData, 'BranchID') || []}
              listWidth="230px"
              dataKey={`BranchName`}
              idKey={`BranchID`}
              disabled={lrSearchCheck}
              // onSelect={(obj) => { setSelSelectedCity(obj); setShowTable(false) }}
              onSelect={(obj) => {
                setSelBranch(obj)
                setShowTable(false)
              }}
              // nextId={id.gbSourceBranch}
              prevId={'goodGoBtn'}
              width={isFromUrl ? "100%" : "350px"}
            />
          </Item>
          <Box sx={{ display: 'inline-flex', padding: '0% 0px', height: '40px' }}>
            <FormControlLabel
              value="end"
              control={
                <Checkbox
                  id="LRSearch"
                  checked={lrSearchCheck}
                  onChange={() => {
                    setLrSearchCheck(!lrSearchCheck)
                  }}
                />
              }
              label={'LR Search?'}
              labelPlacement="end"
            />
          </Box>
          <Item className="input--wrapper" sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <LineInputV3
              // onKeyDown={(e) => {
              //     navigation1(e, 'memoDeliveryReceiverPhone', 'memoTablerowCheck0')
              // }}
              id="memoDeliveryReceiver"
              label="LR No."
              value={lRInput}
              onBlur={(e) => setLRInput(e.target.value)}
            />
          </Item>
          {isFromUrl ?
            <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} >
              DOWNLOAD EXCEL
            </Button> : <>
              <Item sx={sx.itemsx} style={{ cursor: 'pointer' }}>
                {/* <Item sx={sx.itemsx} style={{ cursor: "pointer" }} onKeyDown={(e)=>navigation3(e,showTable?disableExcel?"ExportToPdf":"ExportToExl":id.fromDate,id.anReportOptions,()=>handleClick1())}> */}
                <SplitButton
                  options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                  // hideToggle={true}
                  // id1={id.reportmainButton}
                  // prevID={id.summaryCheck}
                  onClick1={handleClick1}
                  onClick2={handleClick2}
                />
              </Item>
            </>}
        </Box>
        {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}
      </Item>
      {showModel && lrSearchCheck ? (
        <LuggageModel
          updateModal={handleClose}
          lrDetailsPopupData={lrDetailsPopupData}
          setTableData={setTableData}
          setShowModel={setShowModel}
          fromDate={fromDate}
          toDate={toDate}
          selBranch={selBranch}
          lRInput={lRInput}
          onSelectLR={(item) => handleClick1(isFromUrl, item)}
          isFromUrl={isFromUrl}
        />
      ) : null}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getLuggageModificationReportData, GetLRDetailsForPopUpV2Data, getFtlBkngBranchList, updateLoader }
export default connect(mapStateToProps, mapDispatchToProps)(LuggageModificationReport)
